// assets/js/app.js
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

document.documentElement.classList.add('js-enabled');

// --- IMPORTS DES MODULES ---
import { initCf7MessageCounter } from './form.js';
import './mega-menu.js';
import { initHiTechReveal } from './hi-tech-animations.js';
import { initHiTechVideoBlocks } from './video-block.js';
import { initHiTechVideoModal } from './video-modal.js';
import { initBrandSlider } from './brands-slider.js';
import { initSmoothAnchors } from './smooth-anchors.js';
import { initSolutionsHero } from './solutions-hero.js';
import { initHiTechCounters } from './hi-tech-counters.js';
import './history-timeline.js';
import { initProductFeaturesSplide } from './product-features-splide.js';
import { initMobileNav } from './mobile-nav.js';
import './references-filters';
import { initLightbox } from './lightbox';
import './sliders/shader-carousel.js';

// 👇 Tes modules de Géolocalisation et Notification
import { initGeoRouting } from './geo-routing.js';
import { initCrossSiteNotification } from './cross-site-notification.js'; // <--- NOUVEAU


// --- INITIALISATIONS ---

initHiTechReveal();
initHiTechVideoModal();
initBrandSlider();
initSmoothAnchors();
initSolutionsHero();
initHiTechCounters();
initMobileNav();

initHiTechVideoBlocks({
  // options...
});


document.addEventListener('DOMContentLoaded', () => {
  // Logique UI Mobile simple
  const items = document.querySelectorAll('.companion-mobile__item');
  items.forEach((btn) => {
    btn.addEventListener('touchstart', () => { btn.classList.add('is-tapping'); });
    btn.addEventListener('touchend', () => { btn.classList.remove('is-tapping'); });
  });

  // Initialisation des modules au chargement complet
  initProductFeaturesSplide();
  initLightbox();
  initCf7MessageCounter();
  
  // 🌍 Le cerveau GeoIP (Modal popup)
  initGeoRouting(); 

  // 🔔 La notification "Vous venez de France" (Bandeau)
  initCrossSiteNotification(); 
});